/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdRoles200,
  GetApiV1PersonIdRoles401,
  GetApiV1PersonIdRoles404,
  GetApiV1PersonIdRoles500,
  GetApiV1PersonIdRolesPathParams,
  GetApiV1PersonIdRolesQueryResponse,
} from "../../types/personRegisterController/GetApiV1PersonIdRoles.ts";
import { personRolesViewModelSchema } from "../personRolesViewModelSchema.ts";

export const getApiV1PersonIdRolesPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdRolesPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdRoles200Schema = z.lazy(
  () => personRolesViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdRoles200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdRoles401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdRoles401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdRoles404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdRoles404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdRoles500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdRoles500>;

export const getApiV1PersonIdRolesQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdRoles200Schema,
) as unknown as ToZod<GetApiV1PersonIdRolesQueryResponse>;
